import * as React from 'react';
import { useStores } from '../../stores';
import { Publisher } from '../../domain/Publisher';
import { observer } from 'mobx-react-lite';
import { useParams } from "react-router-dom";
import { FieldServiceReport } from '../../domain/FieldServiceReport';
import FieldServiceReportDialog from '../../modules/publishers/dialogs/FieldServiceReportDialog';
import { useTranslation } from "react-i18next";
import { useConfirm } from 'material-ui-confirm';
import S4ReportsTable from './S4ReportsTable';
import { useOpenDialog } from '../../hooks/useOpenDialog';

interface Props {
    publisherId?: number;
}

const S4ReportsComponent = observer((props: Props) => {
    const { t } = useTranslation();
    const confirm = useConfirm();
    const { publisherStore, reportStore } = useStores();
    const paramId = useParams().id;
    const publisherId = (paramId && +paramId) || props.publisherId;
    const [publisher, setPublisher] = React.useState<Publisher | undefined>();
    const [selectedReport, setSelectedReport] = React.useState<FieldServiceReport | undefined>();
    const { isOpen, openDialog, closeDialog } = useOpenDialog();

    React.useEffect(() => {
        publisherStore.getPublisher(publisherId!, (p) => {
            setPublisher(p);
            reportStore.getPublisherServiceReports(publisherId!);
        });
    }, [publisherStore, reportStore]);

    const handleReportClick = (id: number) => {
        const report = reportStore.serviceReports[publisherId!] &&
            reportStore.serviceReports[publisherId!]
                .find(report => report.id === id);
        setSelectedReport(report);
        openDialog("submit-report");
    }

    const deleteReport = (id: number) => {
        confirm({
            title: t("are_you_sure"),
            description: `${t("this_will_permanently_delete")}`,
            confirmationText: t("yes"),
            cancellationText: t("no")
        }).then(() => {
            reportStore.deleteReport(id, publisherId!);
        });
    }

    const handleCloseDialog = () => {
        setSelectedReport(undefined);
        closeDialog();
    }

    const reports = (): FieldServiceReport[] => {
        return reportStore.serviceReports[publisherId!] ? reportStore.serviceReports[publisherId!] : [];
    }

    return (
        <>
            <S4ReportsTable
                reports={reports()}
                editable={true}
                onEdit={handleReportClick}
                onDelete={deleteReport}
            />
            <FieldServiceReportDialog
                isOpen={isOpen("submit-report")}
                publisher={publisher!}
                report={selectedReport}
                onClose={handleCloseDialog} />
        </>
    );
});

export default S4ReportsComponent;